import PropTypes from "prop-types";

import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

import "./TopOptionChip.scss";

const TopOptionChip = ({ label }) => (
	<div className="top-option-chip">
		<Typography variant={TYPOGRAPHY_VARIANTS.SMALL}>
			<span
				dangerouslySetInnerHTML={{
					__html: label || "",
				}}
			/>
		</Typography>
	</div>
);

TopOptionChip.propTypes = {
	label: PropTypes.string,
};

export default TopOptionChip;
